import type { DataObject } from '../../generic-types';
import {
  BillcomToZohoBooksHealthCheckNotificationsType,
  BillcomToZohoBooksHealthCheckNotificationsWithCriticalSeverityLevel,
} from './billcom-to-zohobooks-health-check';
import {
  SyncDataProcessLogHealthCheckNotificationsType,
  SyncDataProcessLogHealthCheckNotificationsWithCriticalSeverityLevel,
} from './sync-data-process-log-health-check';
import {
  BillcomHealthCheckNotificationsType,
  BillcomHealthCheckNotificationsWithCriticalSeverityLevel,
} from './billcom-health-check';
import {
  ZohoBooksCheckNotificationsWithCriticalSeverityLevel,
  ZohoBooksHealthCheckNotificationsType,
} from './zoho-books-health-check';
import {
  ZohoCRMHealthCheckNotificationsType,
  ZohoCRMHealthCheckNotificationsWithCriticalSeverityLevel,
} from './zoho-crm-health-check';

export const HealthCheckBaseSystemNotificationsType: DataObject<string> = {
  ...SyncDataProcessLogHealthCheckNotificationsType,
  ...BillcomHealthCheckNotificationsType,
  ...BillcomToZohoBooksHealthCheckNotificationsType,
  ...ZohoBooksHealthCheckNotificationsType,
  ...ZohoCRMHealthCheckNotificationsType,
};

export const HealthCheckBaseSystemNotificationsWithCriticalSeverityLevel: string[] =
  [
    ...SyncDataProcessLogHealthCheckNotificationsWithCriticalSeverityLevel,
    ...BillcomHealthCheckNotificationsWithCriticalSeverityLevel,
    ...BillcomToZohoBooksHealthCheckNotificationsWithCriticalSeverityLevel,
    ...ZohoBooksCheckNotificationsWithCriticalSeverityLevel,
    ...ZohoCRMHealthCheckNotificationsWithCriticalSeverityLevel,
  ];

export type HealthCheckBaseSystemNotificationsTypeValues =
  (typeof HealthCheckBaseSystemNotificationsType)[keyof typeof HealthCheckBaseSystemNotificationsType];

export interface HealthCheckBaseSystemNotificationEventData {
  type: HealthCheckBaseSystemNotificationsTypeValues;
  title: string;
  content: string;
}
